// extracted by mini-css-extract-plugin
module.exports = {"eventEntry":"events-module--eventEntry--29VgM","eventTitle":"events-module--eventTitle--1vM89","image":"events-module--image--1-sdI","imageRow":"events-module--imageRow--36xUG"};